import { StickyLinkCell } from 'src/common/components/ConfigurableTable/Components/Cells/StickyLinkCell';
import { Routes } from 'src/Routes.constants';

export const ESimEIDLinkCell = ({ value }: { value: string }) => {
  return (
    <div data-testid="primaryText">
      <StickyLinkCell value={value || '-'} to={`${Routes.esim}/${value}`} />
    </div>
  );
};
